import React, { useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  Radio,
  Row,
  Spin,
  Table,
  notification,
} from "antd";
import icon from "../../assests/icons/tableIcon.png";
import eyeIcon from "../../assests/icons/tableeye.png";
import { Link } from "react-router-dom";
import handlePost from "../../utils/Post";
import { BASE_URL } from "../../utils/config";
import { useTranslation } from "react-i18next";

const AntDTable = ({ data, loader, link, tabManage, fetchData }) => {
  const [updateStatus, setUpdateStatus] = useState({ id: "", value: "" });
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const {
    Profile,
    Name,
    Username,
    TicketTitle,
    Details,
    Status,
    Pending,
    View,
    TicketId,
  } = t("SupportTicket", { returnObjects: true });
  const userDataLocal = localStorage.getItem("user");
  const user = userDataLocal ? JSON.parse(userDataLocal) : null;

  const handleUpdateStatus = async (id) => {
    if (id === updateStatus?.id) {
      await handlePost(`${BASE_URL}ticket/update/status/${id}`, {
        status: updateStatus?.value,
      });

      if (user?.type !== "user") {
        let endpoint = "ticket/admin/closed/list";

        if (tabManage?.first) endpoint = "ticket/admin/pending/list";
        else if (tabManage?.second) endpoint = "ticket/admin/open/list";

        await fetchData(endpoint, false);
      }
      setUpdateStatus("");
      setOpen(false);
      return;
    }
  };

  const columns = [
    {
      title: Profile,
      
      dataIndex: "profile",
      key: "profile",
      render: (icon) => (
        <img
          className="w-12 h-12 rounded-full"
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9lzsiRta3FMohvPah30I3q-SZ6POEoMZY74pzBP8n2w&s"
          alt=""
        />
      ),
    },
    {
      title: TicketId,
      width:120,
      dataIndex: "id",
      key: "id",
      render: (id) => <a className="font-nunito font-medium">#{id}</a>,
    },
    {
      title: Username,
      dataIndex: "username",
      key: "username",
      render: (username) => (
        <a className="font-nunito font-medium">{username}</a>
      ),
      width:120
    },
    {
      title: "Date",
      dataIndex: "created_at",
      width:120,
      key: "created_at",
      render: (created_at) => {
        const d = new Date(created_at);
        const formattedDate = d.toLocaleDateString();
        const formattedTime = d.toLocaleTimeString();

        return (
          <div className="font-nunito font-medium leading-tight">
            <div>{formattedDate}</div>
            <div className="text-sm text-gray-500">{formattedTime}</div>
          </div>
        );
      },
    },

    {
      title: TicketTitle,
      dataIndex: "title",
      key: "title",
      render: (title) => <p className="font-nunito font-medium">{title}</p>,
    },
    {
      title: Details,
      dataIndex: "detail",
      key: "detail",
      width: 200,
      ellipsis: true,
      render: (detail) => <span className="block truncate">{detail}</span>,
    },

    {
      title: Status,
      key: "status",
      dataIndex: "status",
      render: (status, item) =>
        status === "pending" ? (
          <Dropdown
            open={open === item?.id}
            onOpenChange={setOpen}
            placement="bottomRight"
            trigger={["click"]}
            dropdownRender={() => (
              <div className="w-48 h-40 bg-theme-white dark:bg-[#141b2b] shadow-lg rounded-lg  py-2 px-3">
                <Radio.Group
                  value={item?.id === updateStatus?.id && updateStatus?.value}
                  onChange={(e) =>
                    setUpdateStatus({ id: item?.id, value: e.target.value })
                  }
                  className="flex flex-col"
                >
                  <Radio
                    defaultChecked
                    checked={item?.id === updateStatus?.id}
                    className="font-nunito font-medium my-1"
                    value="open"
                  >
                    OPEN
                  </Radio>
                  <Radio
                    className="font-nunito font-medium my-1"
                    value="closed"
                  >
                    CLOSED
                  </Radio>
                </Radio.Group>
                <Row gutter={6} className="mt-3">
                  <Col>
                    {updateStatus?.id && (
                      <Button onClick={() => handleUpdateStatus(item?.id)}>
                        Update
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          >
            <Button
              onClick={() => (open ? setOpen("") : setOpen(item?.id))}
              className="font-nunito"
            >
              {status}
            </Button>
          </Dropdown>
        ) : (
          <Button className="font-nunito">{status}</Button>
        ),
    },
    {
      title: "Action",
      key: "id",
      width: 110, // 👈 MUST
      align: "center",
      render: (id) => (
        <Link
          to={`${link}/ticket/${id?.id}`}
          className="flex items-center justify-center gap-1 w-full overflow-hidden"
        >
          <img className="w-6 h-6 flex-shrink-0" src={eyeIcon} alt="eyeIcon" />
          <span className="text-xs font-semibold truncate">{View}</span>
        </Link>
      ),
    },
  ];

  return (
    <Table
      rowKey={(item) => item?.id}
      className="font-nunito"
      columns={columns}
      dataSource={data}
      scroll={{ x: 1200 }} // 👈 Important
    />
  );
};

export default AntDTable;
